import { BROWSER_ID } from "shared/constants/LocalStorageConsts";
import { v4 as uuidv4 } from "uuid";

export const loadUserId = (storageBrowserId : string = "") => {
  const browserId = localStorage.getItem(BROWSER_ID);

  return browserId || localStorage.setItem(BROWSER_ID, storageBrowserId || uuidv4());
};

export const getBrowserId: () => string = () => {
  return localStorage.getItem(BROWSER_ID) || "";
};
